import React from 'react'
import { useTranslation } from 'react-i18next'

import Stack from '@mui/material/Stack'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import TooltipIconButton from '../fields/tooltipIconButton'
import { Box, Input } from '@mui/material'

interface SearchFieldProps {
  initialSearchString?: string
  placeholder: string
  onSearch: (searchString: string) => void
}

const SearchField = (props: SearchFieldProps): JSX.Element => {
  const { t } = useTranslation()
  const [searchText, setSearchText] = React.useState<string>(props.initialSearchString || '')
  const [isSearching, setIsSearching] = React.useState<boolean>(false)

  const onSearch = (): void => {
    if (isSearching) {
      props.onSearch(searchText)
    } else {
      setIsSearching(true)
    }
  }

  const clearSearch = () => {
    setIsSearching(false)
    props.onSearch('')
    setSearchText('')
  }
  return (
    <Stack direction="row" spacing={1}>
      <Box sx={{ border: isSearching ? 1 : undefined, borderRadius: 1 }}>
        <Input
          size="small"
          sx={{ display: isSearching ? undefined : 'none', ml: 1 }}
          placeholder={props.placeholder}
          disableUnderline={true}
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value)
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSearch()
            }
          }}
        />
        <TooltipIconButton icon={<SearchIcon />} onClick={onSearch} tooltip={t('listheader.search')} />
      </Box>
      {isSearching && (
        <TooltipIconButton icon={<CloseIcon />} tooltip={t('listheader.clearsearch')} onClick={clearSearch} />
      )}
    </Stack>
  )
}

export default SearchField
